import { useEffect } from 'react';

import { webhooksActions } from '@store/webhooks/webhooks.slice';

import { useCurrentApplication } from '@hook/application/use-current-application.hook';
import { useLazyQuery } from '@hook/common/use-lazy-query.hook';
import { useStoreSelector } from '@hook/store/store.hooks';
import { useLazyLoadWebhookQuery } from '@hook/webhook/webhook.hooks';

export const useConsumerWebhooks = () => {
  const { hasToken, accessToken } = useCurrentApplication();
  const { data, isLoading } = useStoreSelector((state) => state.webhooks);

  const { action } = useLazyQuery(useLazyLoadWebhookQuery(), webhooksActions, webhooksActions.setData);

  useEffect(() => void (hasToken && action()), [hasToken, accessToken]);

  return { data: Object.values(data), isLoading };
};
